import { PayloadAction } from "@reduxjs/toolkit";
import { SessionState } from "../session.slice.ts";
import { SessionInfoResponse } from "../../../../orchestrator-api-client";

export default function initStoreReducer(
  state: SessionState,
  action: PayloadAction<SessionInfoResponse | undefined>,
) {
  if (action.payload) {
    state.token = action.payload.session?.token ?? "";
  }
}
